import React from "react";
import classes from "./FooterCarousel.module.css";

const logos = [
    "/images/brand-carousel2/footer1.png",
    "/images/brand-carousel2/footer2.png",
    "/images/brand-carousel2/footer3.png",
    "/images/brand-carousel2/footer4.png",
    "/images/brand-carousel2/footer5.png",
    "/images/brand-carousel2/footer1.png",
    "/images/brand-carousel2/footer2.png",
    "/images/brand-carousel2/footer3.png",
    "/images/brand-carousel2/footer4.png",
    "/images/brand-carousel2/footer5.png",
];

const FooterCarousel = () => {
    return (
        <section className={classes.logoSection}>

            {/* <div className={classes.topGlow} /> */}

            <div className={classes.section_carousel_marquee}>
                <div className={classes.section_carousel_sub_container}>
                    {logos.map((item, index) => {
                        return (
                            <div key={index} className={classes.section_carousel_item}>
                                <img src={item} alt="" className={classes.section_carousel_item_image} />
                            </div>
                        )
                    })}

                    {logos.map((item, index) => {
                        return (
                            <div key={index} className={classes.section_carousel_item}>
                                <img src={item} alt="" className={classes.section_carousel_item_image} />
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    );
};

export default FooterCarousel;